var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column has-text-right correction-section"},[_c('a',{staticClass:"button is-primary",attrs:{"target":"_blank","rel":"noopener","href":_vm.correctionsLink}},[_vm._v(_vm._s(_vm.correctionsText))])])}
var staticRenderFns = []

export { render, staticRenderFns }